var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm.product !== null || _vm.isProductLoading
        ? _c("div", { staticClass: "my-5" }, [
            _vm.product !== null && _vm.product.isVisible
              ? _c(
                  "div",
                  {
                    attrs: {
                      itemscope: "",
                      itemtype: "https://schema.org/Product"
                    }
                  },
                  [
                    _vm.product.metaData.product.sku !== null
                      ? _c("meta", {
                          attrs: {
                            itemprop: "sku",
                            content: _vm.product.metaData.product.sku
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.product.metaData.product.gtin !== ""
                      ? _c("meta", {
                          attrs: {
                            itemprop: "gtin",
                            content: _vm.product.metaData.product.gtin
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("meta", {
                      attrs: {
                        itemprop: "category",
                        content: _vm.product.metaData.product.category
                      }
                    }),
                    _vm._v(" "),
                    _c("meta", {
                      attrs: {
                        itemprop: "name",
                        content: _vm.product.metaData.product.name
                      }
                    }),
                    _vm._v(" "),
                    _c("meta", {
                      attrs: {
                        itemprop: "description",
                        content: _vm.product.metaData.product.description
                      }
                    }),
                    _vm._v(" "),
                    _c("meta", {
                      attrs: {
                        itemprop: "image",
                        content: _vm.product.metaData.product.image
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        attrs: {
                          itemprop: "offers",
                          itemscope: "",
                          itemtype: "https://schema.org/Offer"
                        }
                      },
                      [
                        _c("meta", {
                          attrs: {
                            itemprop: "url",
                            content: _vm.product.metaData.product.offers.url
                          }
                        }),
                        _vm._v(" "),
                        _c("meta", {
                          attrs: {
                            itemprop: "priceCurrency",
                            content:
                              _vm.product.metaData.product.offers.priceCurrency
                          }
                        }),
                        _vm._v(" "),
                        _c("meta", {
                          attrs: {
                            itemprop: "price",
                            content: _vm.product.metaData.product.offers.price
                          }
                        }),
                        _vm._v(" "),
                        _c("meta", {
                          attrs: {
                            itemprop: "priceValidUntil",
                            content:
                              _vm.product.metaData.product.offers
                                .priceValidUntil
                          }
                        }),
                        _vm._v(" "),
                        _c("link", {
                          attrs: {
                            itemprop: "availability",
                            href:
                              _vm.product.metaData.product.offers.availability
                          }
                        }),
                        _vm._v(" "),
                        _c("link", {
                          attrs: {
                            itemprop: "itemCondition",
                            href: "https://schema.org/NewCondition"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        attrs: {
                          itemprop: "brand",
                          itemscope: "",
                          itemtype: "https://schema.org/Brand"
                        }
                      },
                      [
                        _c("meta", {
                          attrs: {
                            itemprop: "logo",
                            content: _vm.product.metaData.product.brand.logo
                          }
                        }),
                        _vm._v(" "),
                        _c("meta", {
                          attrs: {
                            itemprop: "name",
                            content: _vm.product.metaData.product.brand.name
                          }
                        }),
                        _vm._v(" "),
                        _c("meta", {
                          attrs: {
                            itemprop: "url",
                            content: _vm.product.metaData.product.brand.url
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _vm.product && !_vm.product.isAdsFreeProduct
                      ? [
                          "aggregateRating" in _vm.product.metaData.product
                            ? [
                                _c(
                                  "div",
                                  {
                                    attrs: {
                                      itemprop: "aggregateRating",
                                      itemscope: "",
                                      itemtype:
                                        "https://schema.org/AggregateRating"
                                    }
                                  },
                                  [
                                    _c("meta", {
                                      attrs: {
                                        itemprop: "ratingValue",
                                        content:
                                          _vm.product.metaData.product
                                            .aggregateRating.ratingValue
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("meta", {
                                      attrs: {
                                        itemprop: "reviewCount",
                                        content:
                                          _vm.product.metaData.product
                                            .aggregateRating.reviewCount
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("meta", {
                                      attrs: {
                                        itemprop: "bestRating",
                                        content: "5"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("meta", {
                                      attrs: {
                                        itemprop: "worstRating",
                                        content: "1"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                "reviewList" in _vm.product.metaData
                                  ? _vm._l(
                                      _vm.product.metaData.reviewList,
                                      function(review) {
                                        return _c(
                                          "div",
                                          {
                                            key: review.id,
                                            attrs: {
                                              itemscope: "",
                                              itemprop: "review",
                                              itemtype:
                                                "https://schema.org/Review"
                                            }
                                          },
                                          [
                                            _c("meta", {
                                              attrs: {
                                                itemprop: "itemReviewed",
                                                content: review.productName
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("meta", {
                                              attrs: {
                                                itemprop: "datePublished",
                                                content: review.date
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("meta", {
                                              attrs: {
                                                itemprop: "reviewBody",
                                                content: review.text
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                attrs: {
                                                  itemscope: "",
                                                  itemprop: "author",
                                                  itemtype:
                                                    "https://schema.org/Person"
                                                }
                                              },
                                              [
                                                _c("meta", {
                                                  attrs: {
                                                    itemprop: "name",
                                                    content: review.userName
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "oneReview",
                                                attrs: {
                                                  itemprop: "reviewRating",
                                                  itemscope: "",
                                                  itemtype:
                                                    "https://schema.org/Rating"
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      itemscope: "",
                                                      itemprop: "author",
                                                      itemtype:
                                                        "https://schema.org/Person"
                                                    }
                                                  },
                                                  [
                                                    _c("meta", {
                                                      attrs: {
                                                        itemprop: "name",
                                                        content: review.userName
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("meta", {
                                                  attrs: {
                                                    itemprop: "ratingValue",
                                                    content: review.ratingValue
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("meta", {
                                                  attrs: {
                                                    itemprop: "worstRating",
                                                    content: "1"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("meta", {
                                                  attrs: {
                                                    itemprop: "bestRating",
                                                    content: "5"
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      }
                                    )
                                  : _vm._e()
                              ]
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isProductLoading || _vm.product.isVisible
              ? _c(
                  "div",
                  [
                    _c("div", { staticClass: "d-flex" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 col-md-7 col-xl-8 product-desc p-0 pr-md-4",
                          class: {
                            loading: _vm.isProductLoading
                          }
                        },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "b-skeleton-wrapper",
                                {
                                  attrs: { loading: _vm.isProductLoading },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "loading",
                                        fn: function() {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "w-100 h-100 skeleton-div"
                                              },
                                              [
                                                _c("b-skeleton-img", {
                                                  staticClass: "skeleton-image",
                                                  attrs: {
                                                    "no-aspect": "",
                                                    animation: "fade"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    636920236
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  !_vm.isProductLoading
                                    ? _c("product-image", {
                                        attrs: {
                                          "image-list": _vm.product.imageList,
                                          "product-name": _vm.product.name,
                                          "is-loading": _vm.isProductLoading
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _vm.isMobile
                                ? _c(
                                    "b-skeleton-wrapper",
                                    {
                                      attrs: { loading: _vm.isProductLoading },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "loading",
                                            fn: function() {
                                              return [
                                                _c("b-skeleton", {
                                                  staticClass:
                                                    "skeleton-text-link-size w-25",
                                                  attrs: { animation: "fade" }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "mt-2" },
                                                  [
                                                    _c("b-skeleton", {
                                                      staticClass:
                                                        "skeleton-text-name-size",
                                                      attrs: {
                                                        animation: "fade"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("b-skeleton", {
                                                      staticClass:
                                                        "skeleton-text-name-size",
                                                      attrs: {
                                                        animation: "fade"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "my-2" },
                                                  [
                                                    _c("b-skeleton", {
                                                      staticClass:
                                                        "skeleton-text-price-size w-25",
                                                      attrs: {
                                                        animation: "fade"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "my-2" },
                                                  [
                                                    _c("b-skeleton", {
                                                      staticClass:
                                                        "skeleton-text-mass-price-size w-25",
                                                      attrs: {
                                                        animation: "fade"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "my-2" },
                                                  [
                                                    _c("b-skeleton", {
                                                      staticClass:
                                                        "skeleton-text-link-size w-25",
                                                      attrs: {
                                                        animation: "fade"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("b-skeleton", {
                                                      staticClass:
                                                        "skeleton-text-link-size w-50",
                                                      attrs: {
                                                        animation: "fade"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "mb-4" },
                                                  [
                                                    _c("b-skeleton", {
                                                      staticClass:
                                                        "skeleton-select w-100 mb-4",
                                                      attrs: {
                                                        animation: "fade"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "mb-4" },
                                                  [
                                                    _c("b-skeleton", {
                                                      staticClass:
                                                        "skeleton-select w-100 mb-4",
                                                      attrs: {
                                                        animation: "fade"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "mt-4" },
                                                  [
                                                    _c("b-skeleton-img", {
                                                      attrs: {
                                                        animation: "fade",
                                                        height: "388px"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        false,
                                        3460752439
                                      )
                                    },
                                    [
                                      _vm._v(" "),
                                      !_vm.isProductLoading
                                        ? _c("product-add-to-cart", {
                                            staticClass: "mb-3",
                                            attrs: {
                                              product: _vm.product,
                                              "is-other-component-selects-valid":
                                                _vm.isOtherComponentSelectsValid,
                                              "selected-color":
                                                _vm.selectedColor,
                                              "selected-size": _vm.selectedSize,
                                              "selected-flavor":
                                                _vm.selectedFlavor,
                                              quantity: _vm.quantity,
                                              "is-assembly-checked":
                                                _vm.isAssemblyChecked,
                                              "current-price-formatted":
                                                _vm.currentPriceFormatted,
                                              "dosen-price-list":
                                                _vm.product.dosenPrices,
                                              "is-product-add-to-cart-in-progress":
                                                _vm.isProductAddToCartInProgress
                                            },
                                            on: {
                                              flavorSelected:
                                                _vm.flavorSelected,
                                              colorSelected: _vm.colorSelected,
                                              sizeSelected: _vm.sizeSelected,
                                              quantityIncreased:
                                                _vm.quantityIncreased,
                                              quantityDecreased:
                                                _vm.quantityDecreased,
                                              quantitySelected:
                                                _vm.quantitySelected,
                                              addToCart: _vm.addToCart,
                                              assemblyChanged:
                                                _vm.assemblyChanged,
                                              productCardAddToCart:
                                                _vm.productCardAddToCart,
                                              updateGiftProduct:
                                                _vm.updateGiftProduct,
                                              updateProductPackageItem:
                                                _vm.updateProductPackageItem,
                                              isValidChanged: _vm.isValidChanged
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.isProductLoading || !_vm.product.isAdsFreeProduct
                            ? [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "b-skeleton-wrapper",
                                      {
                                        attrs: {
                                          loading: _vm.isProductLoading
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "loading",
                                              fn: function() {
                                                return [
                                                  _c("b-skeleton", {
                                                    staticClass:
                                                      "title mt-4 skeleton",
                                                    attrs: { animation: "fade" }
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          false,
                                          353593021
                                        )
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("h2", {
                                          directives: [
                                            {
                                              name: "t",
                                              rawName: "v-t",
                                              value:
                                                "term_reszletes_velemenyek",
                                              expression:
                                                "'term_reszletes_velemenyek'"
                                            }
                                          ],
                                          staticClass: "title mt-4"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "my-4" },
                                  [
                                    _c(
                                      "b-skeleton-wrapper",
                                      {
                                        attrs: {
                                          loading: _vm.isProductLoading
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "loading",
                                              fn: function() {
                                                return [
                                                  _c("b-skeleton", {
                                                    staticClass:
                                                      "w-25 skeleton-rating-text",
                                                    attrs: { animation: "fade" }
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          false,
                                          3360917242
                                        )
                                      },
                                      [
                                        _vm._v(" "),
                                        !_vm.isProductLoading
                                          ? _c("rating-stars", {
                                              attrs: {
                                                rating: _vm.product.rateValue,
                                                "review-count":
                                                  _vm.product.reviewCount,
                                                "is-rate-num-visible": true
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "b-skeleton-wrapper",
                                      {
                                        attrs: {
                                          loading: _vm.isProductLoading
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "loading",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "skeleton-review-wrapper"
                                                    },
                                                    [
                                                      _c("b-skeleton", {
                                                        staticClass:
                                                          "w-100 skeleton-normal-text",
                                                        attrs: {
                                                          animation: "fade"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          false,
                                          3388108615
                                        )
                                      },
                                      [
                                        _vm._v(" "),
                                        !_vm.isProductLoading
                                          ? _vm._l(
                                              _vm.product.reviewBarData,
                                              function(reviewBar) {
                                                return _c("review-bar", {
                                                  key: reviewBar.starCount,
                                                  staticClass: "my-2",
                                                  attrs: {
                                                    "star-count":
                                                      reviewBar.starCount,
                                                    percent: reviewBar.percent,
                                                    "is-loading":
                                                      _vm.isProductLoading
                                                  }
                                                })
                                              }
                                            )
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-column align-items-start w-100"
                                  },
                                  [
                                    _c(
                                      "b-skeleton-wrapper",
                                      {
                                        staticClass: "w-100",
                                        attrs: {
                                          loading: _vm.isProductLoading
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "loading",
                                              fn: function() {
                                                return [
                                                  _c("b-skeleton", {
                                                    staticClass:
                                                      "skeleton-normal-text w-25"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("b-skeleton", {
                                                    staticClass:
                                                      "skeleton-question-btn w-25"
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          false,
                                          3878091427
                                        )
                                      },
                                      [
                                        _vm._v(" "),
                                        !_vm.isProductLoading
                                          ? [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: _vm.product.reviewsUrl
                                                  }
                                                },
                                                [
                                                  _c("span", {
                                                    directives: [
                                                      {
                                                        name: "t",
                                                        rawName: "v-t",
                                                        value:
                                                          "menu_shop_osszes_velemeny",
                                                        expression:
                                                          "'menu_shop_osszes_velemeny'"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "reviews-text my-4",
                                                    attrs: {
                                                      "data-cy":
                                                        "all-ratings-btn"
                                                    }
                                                  }),
                                                  _vm._v(
                                                    " (" +
                                                      _vm._s(
                                                        _vm.product.reviewCount
                                                      ) +
                                                      ")\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: _vm.product.questionsUrl
                                                  }
                                                },
                                                [
                                                  _c("button", {
                                                    directives: [
                                                      {
                                                        name: "t",
                                                        rawName: "v-t",
                                                        value:
                                                          "kerdes_termekrol",
                                                        expression:
                                                          "'kerdes_termekrol'"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "custom-button unfilled my-4",
                                                    attrs: {
                                                      "data-cy":
                                                        "product-question-btn"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "observe-visibility",
                                  rawName: "v-observe-visibility",
                                  value:
                                    _vm.productDescriptionVisibilityChanged,
                                  expression:
                                    "productDescriptionVisibilityChanged"
                                }
                              ]
                            },
                            [
                              _vm.isProductDescriptionVisible
                                ? [
                                    _c(
                                      "b-skeleton-wrapper",
                                      {
                                        staticClass: "w-100",
                                        attrs: {
                                          loading: _vm.isProductLoading
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "loading",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "skeleton-title-wrapper"
                                                    },
                                                    [
                                                      _c("b-skeleton", {
                                                        staticClass:
                                                          "w-50 skeleton-title",
                                                        attrs: {
                                                          animation: "fade"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(10, function(index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: index,
                                                        staticClass: "mt-4 mb-4"
                                                      },
                                                      [
                                                        _c("b-skeleton", {
                                                          staticClass: "w-50",
                                                          attrs: {
                                                            animation: "fade"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("b-skeleton", {
                                                          staticClass: "w-100",
                                                          attrs: {
                                                            animation: "fade"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("b-skeleton", {
                                                          staticClass: "w-75",
                                                          attrs: {
                                                            animation: "fade"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("b-skeleton", {
                                                          staticClass: "w-25",
                                                          attrs: {
                                                            animation: "fade"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          false,
                                          3585647370
                                        )
                                      },
                                      [
                                        _vm._v(" "),
                                        !_vm.isProductLoading
                                          ? [
                                              _vm.product.isVirtualProduct &&
                                              _vm.product
                                                .hasAccessToVirtualProduct &&
                                              _vm.product.hasDigitalContent
                                                ? _c("div", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.product
                                                          .digitalContent
                                                      )
                                                    }
                                                  })
                                                : [
                                                    _c("h2", {
                                                      directives: [
                                                        {
                                                          name: "t",
                                                          rawName: "v-t",
                                                          value:
                                                            "term_termekleiras_label",
                                                          expression:
                                                            "'term_termekleiras_label'"
                                                        }
                                                      ],
                                                      staticClass: "title"
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.product.description !==
                                                    ""
                                                      ? _c(
                                                          "text-and-widget-display",
                                                          {
                                                            staticClass:
                                                              "description-body my-4",
                                                            attrs: {
                                                              "text-body":
                                                                _vm.product
                                                                  .description
                                                            }
                                                          }
                                                        )
                                                      : _c("div", {
                                                          directives: [
                                                            {
                                                              name: "t",
                                                              rawName: "v-t",
                                                              value:
                                                                "term_nincstermekleiras_label",
                                                              expression:
                                                                "'term_nincstermekleiras_label'"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "text-center my-4"
                                                        }),
                                                    _vm._v(" "),
                                                    _vm.product
                                                      .videoAdWidget !== ""
                                                      ? _c(
                                                          "text-and-widget-display",
                                                          {
                                                            staticClass:
                                                              "description-body",
                                                            attrs: {
                                                              "text-body":
                                                                _vm.product
                                                                  .videoAdWidget
                                                            }
                                                          }
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.product
                                                      .isVirtualProduct &&
                                                    _vm.product
                                                      .hasDigitalContent
                                                      ? _c(
                                                          "div",
                                                          [
                                                            _c("div", {
                                                              domProps: {
                                                                innerHTML: _vm._s(
                                                                  _vm.$t(
                                                                    "digital_content_information"
                                                                  )
                                                                )
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            !_vm.isLoggedIn
                                                              ? [
                                                                  _c("div", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "t",
                                                                        rawName:
                                                                          "v-t",
                                                                        value:
                                                                          "digital_content_not_registered",
                                                                        expression:
                                                                          "'digital_content_not_registered'"
                                                                      }
                                                                    ]
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "router-link",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "t",
                                                                          rawName:
                                                                            "v-t",
                                                                          value:
                                                                            "bejelentkezes_kerese",
                                                                          expression:
                                                                            "'bejelentkezes_kerese'"
                                                                        }
                                                                      ],
                                                                      attrs: {
                                                                        to:
                                                                          "/login"
                                                                      }
                                                                    }
                                                                  )
                                                                ]
                                                              : !_vm.product
                                                                  .hasAccessToVirtualProduct
                                                              ? [
                                                                  _c("div", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "t",
                                                                        rawName:
                                                                          "v-t",
                                                                        value:
                                                                          "digital_content_not_ordered",
                                                                        expression:
                                                                          "'digital_content_not_ordered'"
                                                                      }
                                                                    ]
                                                                  })
                                                                ]
                                                              : _vm._e()
                                                          ],
                                                          2
                                                        )
                                                      : _vm._e()
                                                  ]
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.isProductDescriptionVisible
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-skeleton-wrapper",
                                    {
                                      attrs: { loading: _vm.isProductLoading },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "loading",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "skeleton-title-wrapper"
                                                  },
                                                  [
                                                    _c("b-skeleton", {
                                                      staticClass:
                                                        "w-50 skeleton-title",
                                                      attrs: {
                                                        animation: "fade"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("b-skeleton", {
                                                  staticClass:
                                                    "composition-skeleton",
                                                  attrs: { animation: "fade" }
                                                })
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        false,
                                        53573785
                                      )
                                    },
                                    [
                                      _vm._v(" "),
                                      _vm.product &&
                                      !_vm.product.isAdsFreeProduct &&
                                      _vm.compositionCount > 0 &&
                                      !_vm.isProductLoading
                                        ? _c("div", [
                                            _vm.currentCompositionsToShow
                                              .length !== 0
                                              ? _c("h2", {
                                                  directives: [
                                                    {
                                                      name: "t",
                                                      rawName: "v-t",
                                                      value:
                                                        "term_reszletes_osszetetel",
                                                      expression:
                                                        "'term_reszletes_osszetetel'"
                                                    }
                                                  ],
                                                  staticClass: "title"
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "w-100" },
                                              [
                                                _vm.currentCompositionsToShow
                                                  .length !== 0
                                                  ? _vm._l(
                                                      _vm.currentCompositionsToShow,
                                                      function(
                                                        compositionData,
                                                        compositionIndex
                                                      ) {
                                                        return _c(
                                                          "composition",
                                                          {
                                                            key: compositionIndex,
                                                            staticClass: "mt-4",
                                                            attrs: {
                                                              "composition-data": compositionData
                                                            }
                                                          }
                                                        )
                                                      }
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "my-4" },
                                                  [
                                                    _vm.compositionCount >
                                                    _vm
                                                      .currentCompositionsToShow
                                                      .length
                                                      ? _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to:
                                                                _vm.product
                                                                  .compositionsUrl
                                                            }
                                                          },
                                                          [
                                                            _c("span", {
                                                              directives: [
                                                                {
                                                                  name: "t",
                                                                  rawName:
                                                                    "v-t",
                                                                  value:
                                                                    "more_compositions",
                                                                  expression:
                                                                    "'more_compositions'"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "compositions-text"
                                                            })
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ],
                                              2
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: {
                            "right-bar-loading": _vm.isProductLoading
                          }
                        },
                        [
                          !_vm.isMobile
                            ? _c(
                                "b-skeleton-wrapper",
                                {
                                  attrs: { loading: _vm.isProductLoading },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "loading",
                                        fn: function() {
                                          return [
                                            _c("b-skeleton", {
                                              staticClass:
                                                "skeleton-text-link-size w-25",
                                              attrs: { animation: "fade" }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "mt-2" },
                                              [
                                                _c("b-skeleton", {
                                                  staticClass:
                                                    "skeleton-text-name-size",
                                                  attrs: { animation: "fade" }
                                                }),
                                                _vm._v(" "),
                                                _c("b-skeleton", {
                                                  staticClass:
                                                    "skeleton-text-name-size",
                                                  attrs: { animation: "fade" }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "my-2" },
                                              [
                                                _c("b-skeleton", {
                                                  staticClass:
                                                    "skeleton-text-price-size w-25",
                                                  attrs: { animation: "fade" }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "my-2" },
                                              [
                                                _c("b-skeleton", {
                                                  staticClass:
                                                    "skeleton-text-mass-price-size w-25",
                                                  attrs: { animation: "fade" }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "my-2" },
                                              [
                                                _c("b-skeleton", {
                                                  staticClass:
                                                    "skeleton-text-link-size w-25",
                                                  attrs: { animation: "fade" }
                                                }),
                                                _vm._v(" "),
                                                _c("b-skeleton", {
                                                  staticClass:
                                                    "skeleton-text-link-size w-50",
                                                  attrs: { animation: "fade" }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "mb-4" },
                                              [
                                                _c("b-skeleton", {
                                                  staticClass:
                                                    "skeleton-select w-100 mb-4",
                                                  attrs: { animation: "fade" }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "mb-4" },
                                              [
                                                _c("b-skeleton", {
                                                  staticClass:
                                                    "skeleton-select w-100 mb-4",
                                                  attrs: { animation: "fade" }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "mt-4" },
                                              [
                                                _c("b-skeleton-img", {
                                                  attrs: {
                                                    animation: "fade",
                                                    height: "388px"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    3460752439
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  !_vm.isProductLoading
                                    ? _c("product-add-to-cart", {
                                        attrs: {
                                          product: _vm.product,
                                          "is-other-component-selects-valid":
                                            _vm.isOtherComponentSelectsValid,
                                          "selected-color": _vm.selectedColor,
                                          "selected-size": _vm.selectedSize,
                                          "selected-flavor": _vm.selectedFlavor,
                                          quantity: _vm.quantity,
                                          "is-assembly-checked":
                                            _vm.isAssemblyChecked,
                                          "current-price-formatted":
                                            _vm.currentPriceFormatted,
                                          "dosen-price-list":
                                            _vm.product.dosenPrices,
                                          "is-product-add-to-cart-in-progress":
                                            _vm.isProductAddToCartInProgress
                                        },
                                        on: {
                                          flavorSelected: _vm.flavorSelected,
                                          colorSelected: _vm.colorSelected,
                                          sizeSelected: _vm.sizeSelected,
                                          quantityIncreased:
                                            _vm.quantityIncreased,
                                          quantityDecreased:
                                            _vm.quantityDecreased,
                                          quantitySelected:
                                            _vm.quantitySelected,
                                          addToCart: _vm.addToCart,
                                          assemblyChanged: _vm.assemblyChanged,
                                          productCardAddToCart:
                                            _vm.productCardAddToCart,
                                          updateGiftProduct:
                                            _vm.updateGiftProduct,
                                          updateProductPackageItem:
                                            _vm.updateProductPackageItem,
                                          isValidChanged: _vm.isValidChanged
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.product !== null && !_vm.product.isAdsFreeProduct
                      ? [
                          _c(
                            "div",
                            [
                              _c(
                                "b-skeleton-wrapper",
                                {
                                  attrs: { loading: _vm.isProductLoading },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "loading",
                                        fn: function() {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-center mt-5"
                                              },
                                              [
                                                _c("b-skeleton", {
                                                  staticClass: "w-25 py-3"
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mt-4 mb-2 d-flex justify-content-center"
                                              },
                                              [
                                                _c("candy-bar", {
                                                  staticClass: "col-11",
                                                  attrs: {
                                                    "is-loading": true,
                                                    "product-list": []
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    3085468375
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _vm.product.similarItemList.length > 0 &&
                                  !_vm.isProductLoading
                                    ? _c("candy-bar", {
                                        staticClass: "mt-2 mb-4 px-xl-4",
                                        attrs: {
                                          title: _vm.$t("hasonlo_termekek"),
                                          "product-list":
                                            _vm.product.similarItemList
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.product.relevantArticleList.length > 0
                            ? _c("div", [
                                _c("div", {
                                  directives: [
                                    {
                                      name: "t",
                                      rawName: "v-t",
                                      value: "kapcsolodo_cikkek_label",
                                      expression: "'kapcsolodo_cikkek_label'"
                                    }
                                  ],
                                  staticClass:
                                    "article-bar-title my-3 col-12 text-center"
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-wrap" },
                                  _vm._l(
                                    _vm.product.relevantArticleList,
                                    function(article) {
                                      return _c("article-card", {
                                        key: article.id,
                                        staticClass: "col-12 col-md-6 my-2",
                                        attrs: {
                                          article: article,
                                          "is-overlay-type": true,
                                          "is-loading": _vm.isProductLoading
                                        }
                                      })
                                    }
                                  ),
                                  1
                                )
                              ])
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
                  2
                )
              : _c(
                  "div",
                  [
                    _c("div", { staticClass: "text-center" }, [
                      _c("h1", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.product.name) +
                            " - " +
                            _vm._s(_vm.product.brandName) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "nem_lathato_termekoldal_leiras",
                            expression: "'nem_lathato_termekoldal_leiras'"
                          }
                        ],
                        staticClass: "my-3"
                      }),
                      _vm._v(" "),
                      "imgSrc" in _vm.product.replaceData &&
                      _vm.product.replaceData.imgSrc !== ""
                        ? _c("h2", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "nem_lathato_termekoldal_magyarazat",
                                expression:
                                  "'nem_lathato_termekoldal_magyarazat'"
                              }
                            ],
                            staticClass: "mb-3"
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    "imgSrc" in _vm.product.replaceData &&
                    _vm.product.replaceData.imgSrc !== ""
                      ? _c(
                          "router-link",
                          {
                            attrs: {
                              to: _vm.product.replaceData.url,
                              title: _vm.product.replaceData.name
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "w-100",
                              attrs: { src: _vm.product.replaceData.imgSrc }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    "replaceItemList" in _vm.product.replaceData &&
                    _vm.product.replaceData.replaceItemList.length > 0
                      ? _c("candy-bar", {
                          staticClass: "mt-2 mb-4 px-xl-4",
                          attrs: {
                            title: _vm.$t("replace_products_label"),
                            "product-list":
                              _vm.product.replaceData.replaceItemList
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    "otherProductsInCategoryItemList" in
                      _vm.product.replaceData &&
                    _vm.product.replaceData.otherProductsInCategoryItemList
                      .length > 0
                      ? _c(
                          "div",
                          [
                            _c("div", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "replace_products_list_label",
                                  expression: "'replace_products_list_label'"
                                }
                              ],
                              staticClass:
                                "item-list-title col-12 text-center my-3"
                            }),
                            _vm._v(" "),
                            _c("item-list-items", {
                              attrs: {
                                items:
                                  _vm.product.replaceData
                                    .otherProductsInCategoryItemList
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    "recommendedItemList" in _vm.product.replaceData &&
                    _vm.product.replaceData.recommendedItemList.length > 0
                      ? _c("candy-bar", {
                          staticClass: "mt-2 mb-4 px-xl-4",
                          attrs: {
                            title: _vm.$t("neked_ajanljuk"),
                            "product-list":
                              _vm.product.replaceData.recommendedItemList
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
          ])
        : _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-center align-items-center error-container"
            },
            [
              _c("h4", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "sikertelen_muvelet",
                    expression: "'sikertelen_muvelet'"
                  }
                ]
              })
            ]
          ),
      _vm._v(" "),
      _vm.currentProductIdForAddToCartModal !== null
        ? _c("add-to-cart-modal", {
            attrs: { "product-id": _vm.currentProductIdForAddToCartModal },
            on: {
              close: function($event) {
                _vm.currentProductIdForAddToCartModal = null
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }